// import React, { useState, useEffect } from 'react';

import React from 'react';

// import qs from 'qs';

// import api from '~/services/api';

// import {
//   Scroll,
//   Container,
//   Header,
//   Progress,
//   Select,
//   Plate,
// } from '~/components';

// import {
//   Content,
//   FilterRoot,
//   Metrics,
//   Metric,
//   Area,
//   Space,
//   Title,
//   Graph,
//   Block,
// } from './styles';

// import { SelectItemProps } from '~/components/Form/Select/interface';

// import RevendedorType from '~/@types/revendedor';
// import MetricaType from '~/@types/metrica';

// import Graph1 from './Graph1';
// import Graph2 from './Graph2';
// import Graph3 from './Graph3';

// import Grid from './Grid';

const Dashboard: React.FC = () => {
  // const [inLoad, setInLoad] = useState(false);

  // const [metrica, setMetrica] = useState<MetricaType | null>(null);

  // //REVENDEDOR
  // const [slctColaborador, setSlctColaborador] = useState(false);
  // const [revendedores, setColaboradores] = useState<SelectItemProps[]>([]);

  // const [revendedor, setColaborador] = useState<SelectItemProps | null>({
  //   label: 'Todos os revendedores',
  //   value: '0',
  // });

  // // REVENDEDOR
  // const onOpenColaborador = () => {
  //   setSlctColaborador(true);
  // };

  // const onCloseColaborador = () => {
  //   setSlctColaborador(false);
  // };

  // const onSelectItemColaborador = (pItem: SelectItemProps) => {
  //   setColaborador(pItem);
  //   onCloseColaborador();
  // };

  // const onSearchColaborador = async (pStrSearch: string) => {
  //   try {
  //     setInLoad(true);

  //     const response = await api.get(`revendedores?busca=${pStrSearch}`);

  //     const { data } = response;

  //     if (data && data.length) {
  //       setColaboradores([
  //         ...data.map((cRevendedor: RevendedorType) => ({
  //           value: cRevendedor.idrevendedor,
  //           label: `${cRevendedor.nome}`,
  //         })),
  //       ]);
  //     }

  //     setInLoad(false);
  //   } catch (e) {
  //     setInLoad(false);
  //   }
  // };

  // useEffect(() => {
  //   const fetchMetricas = async () => {
  //     try {
  //       setInLoad(true);

  //       const response = await api.get(
  //         `dashboard?${qs.stringify({ revendedor: revendedor?.value || '' })}`,
  //       );

  //       const { data } = response;

  //       if (data) {
  //         setMetrica(data);
  //       }

  //       setInLoad(false);
  //     } catch (e) {
  //       setInLoad(false);
  //     }
  //   };

  //   fetchMetricas();
  // }, [revendedor]);

  return <h1>...</h1>;

  // return (
  //   <>
  //     {inLoad ? <Progress /> : null}

  //     {slctColaborador ? (
  //       <Select
  //         isSearch
  //         itens={revendedores}
  //         onClose={onCloseColaborador}
  //         onSearch={onSearchColaborador}
  //         onSelectItem={onSelectItemColaborador}
  //         placeholder="Buscar revendedor..."
  //         title="Colaborador"
  //         value={revendedor}
  //       />
  //     ) : null}

  //     <Scroll>
  //       <Container>
  //         <Header title="Dashboard" subtitle="Vejas as últimas métricas" />

  //         <FilterRoot>
  //           <Plate
  //             placeholder="Selecione um revendedor"
  //             value={revendedor?.label}
  //             onEdit={onOpenColaborador}
  //           />
  //         </FilterRoot>

  //         {metrica ? (
  //           <Content>
  //             <Metrics>
  //               <Metric>
  //                 <Title>Lojas</Title>
  //                 <h1>{metrica.totalLojas}</h1>
  //               </Metric>

  //               <Space />

  //               <Metric>
  //                 <Title>Colaboradores</Title>
  //                 <h1>{metrica.totalColaboradores}</h1>
  //               </Metric>

  //               <Space />

  //               <Metric>
  //                 <Title>Peças Vendidas</Title>
  //                 <h1>{metrica.totalVendasLancadas}</h1>
  //               </Metric>

  //               <Space />

  //               <Metric>
  //                 <Title>Peças (Mês Atual)</Title>
  //                 <h1>{metrica.totalVendasMesAtualLancadas}</h1>
  //               </Metric>
  //             </Metrics>

  //             {metrica.vendasMesAtual.length ? (
  //               <Block>
  //                 <Area>
  //                   <Title>Peças Vendidas nos Últimos 30 dias</Title>
  //                   {metrica.vendasMesAtual.length > 1 ? (
  //                     <Graph>
  //                       <Graph1 data={metrica.vendasMesAtual} />
  //                     </Graph>
  //                   ) : null}
  //                 </Area>
  //               </Block>
  //             ) : null}

  //             {metrica.vendasMensais.length ? (
  //               <Block>
  //                 <Area>
  //                   <Title>Peças Vendidas nos Últimos Meses</Title>
  //                   <Graph>
  //                     {metrica.vendasMensais.length > 1 ? (
  //                       <Graph1 data={metrica.vendasMensais} />
  //                     ) : null}

  //                     <Grid
  //                       data={[
  //                         ...metrica.vendasMensais.map(distribuicao => ({
  //                           prop: distribuicao.data,
  //                           valor: `${distribuicao._total}`,
  //                         })),
  //                       ]}
  //                     />
  //                   </Graph>
  //                 </Area>
  //               </Block>
  //             ) : null}

  //             {metrica.vendasPorLojaMesAtual.length ? (
  //               <Block>
  //                 <Area>
  //                   <Title>Peças por Loja (Mês Atual)</Title>
  //                   <Graph>
  //                     {metrica.vendasPorLojaMesAtual.length > 1 ? (
  //                       <Graph3 data={metrica.vendasPorLojaMesAtual} />
  //                     ) : null}

  //                     <Grid
  //                       data={[
  //                         ...metrica.vendasPorLojaMesAtual.map(
  //                           distribuicao => ({
  //                             bolinha: true,
  //                             cor: distribuicao.cor,
  //                             prop: distribuicao.data,
  //                             valor: `${distribuicao._total}`,
  //                           }),
  //                         ),
  //                       ]}
  //                     />
  //                   </Graph>
  //                 </Area>
  //               </Block>
  //             ) : null}

  //             {metrica.vendasPorColaboradoresMesAtual.length ? (
  //               <Block>
  //                 <Area>
  //                   <Title>Peças por Colaborador (Mês Atual)</Title>
  //                   <Graph>
  //                     {metrica.vendasPorColaboradoresMesAtual.length > 1 ? (
  //                       <Graph3 data={metrica.vendasPorColaboradoresMesAtual} />
  //                     ) : null}

  //                     <Grid
  //                       data={[
  //                         ...metrica.vendasPorColaboradoresMesAtual.map(
  //                           distribuicao => ({
  //                             bolinha: true,
  //                             cor: distribuicao.cor,
  //                             prop: distribuicao.data,
  //                             valor: `${distribuicao._total}`,
  //                           }),
  //                         ),
  //                       ]}
  //                     />
  //                   </Graph>
  //                 </Area>
  //               </Block>
  //             ) : null}

  //             <Block>
  //               <Area>
  //                 <Title>Login</Title>
  //                 <Graph>
  //                   <Graph2 data={metrica.distribuicaoLogins} />

  //                   <Grid
  //                     data={[
  //                       ...metrica.distribuicaoLogins.map(colaborador => ({
  //                         prop: colaborador.data,
  //                       })),
  //                     ]}
  //                   />
  //                 </Graph>
  //               </Area>

  //               <Space />

  //               <Area>
  //                 <Title>Realizaram Login</Title>
  //                 {metrica.logados.length ? (
  //                   <Grid
  //                     data={[
  //                       ...metrica.logados.map(colaborador => ({
  //                         prop: colaborador,
  //                       })),
  //                     ]}
  //                   />
  //                 ) : (
  //                   <p>Nenhum colaborador logado</p>
  //                 )}
  //               </Area>

  //               <Space />

  //               <Area>
  //                 <Title>Não logaram</Title>

  //                 {metrica.naologados.length ? (
  //                   <Grid
  //                     data={[
  //                       ...metrica.naologados.map(colaborador => ({
  //                         prop: colaborador,
  //                         cor: '#df291c',
  //                         bolinha: true,
  //                       })),
  //                     ]}
  //                   />
  //                 ) : (
  //                   <p>Todos os colaboradores logados</p>
  //                 )}
  //               </Area>
  //             </Block>

  //             <Block>
  //               <Area>
  //                 <Title>Ranking de Vendas (Geral)</Title>

  //                 {metrica.rankingDeVendas.length ? (
  //                   <Grid
  //                     data={[
  //                       ...metrica.rankingDeVendas.map((colaborador, idx) => ({
  //                         prop: `${idx + 1}º - ${colaborador.data}`,
  //                         valor: `${colaborador.pecas} Peças`,
  //                       })),
  //                     ]}
  //                   />
  //                 ) : (
  //                   <p>Nenhuma venda ainda</p>
  //                 )}
  //               </Area>

  //               <Space />

  //               <Area>
  //                 <Title>Colaboradores logados (Sem Vendas)</Title>
  //                 {metrica.colaboradoresSemVendas.length ? (
  //                   <Grid
  //                     data={[
  //                       ...metrica.colaboradoresSemVendas.map(colaborador => ({
  //                         prop: colaborador,
  //                         cor: '#df291c',
  //                         bolinha: true,
  //                       })),
  //                     ]}
  //                   />
  //                 ) : (
  //                   <p>Todos colaboradores logados realizaram vendas</p>
  //                 )}
  //               </Area>
  //             </Block>
  //           </Content>
  //         ) : null}
  //       </Container>
  //     </Scroll>
  //   </>
  // );
};

export default Dashboard;
